import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link } from "react-router";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";
import ScrollToTop from "@/src/services/ScrollToTop";

type FeedbackConfirmationPageProps = {
  caseLink: string;
};

export default function FeedbackConfirmationPage({ caseLink }: FeedbackConfirmationPageProps) {
  return (
    <LayoutProtectedRoutes>
      <ScrollToTop />
      <HintBox headline={"Vielen Dank für Ihre Rückmeldung!"}>
        <Typography>
          Wir haben Ihre Rückmeldung erhalten und werden Ihren Fall entsprechend weiter bearbeiten. Sie werden über das weitere Vorgehen wie gewohnt per
          Nachricht und Ihre Servicewelt informiert.
        </Typography>
        <Button component={Link} to={caseLink} variant={"outlined"} sx={{ marginTop: "1rem" }}>
          Zurück zu meinem Fall
        </Button>
      </HintBox>
    </LayoutProtectedRoutes>
  );
}
